// extracted by mini-css-extract-plugin
module.exports = {"works":"Works_works__xjeTu"};